/** Centred empty state — short heading, one sentence, optional action. No illustrations (design.md §6). */
export function EmptyState({
  title,
  message,
  action,
}: {
  title: string
  message?: string
  action?: React.ReactNode
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-border bg-card py-16 text-center">
      <h3 className="text-base font-semibold">{title}</h3>
      {message && <p className="max-w-sm text-sm text-muted-foreground">{message}</p>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  )
}

export function ErrorState({ message, onRetry }: { message?: string; onRetry?: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-destructive/30 bg-destructive/5 py-12 text-center">
      <p className="text-sm text-foreground">{message ?? "Something went wrong loading this view."}</p>
      {onRetry && (
        <button onClick={onRetry} className="text-sm font-medium text-ata-light-blue hover:underline">
          Try again
        </button>
      )}
    </div>
  )
}
